var CONST_ERRORS = require('../../constants/errors');

function UserCanceledPayment(paymentBrand) {
  this.paymentBrand = paymentBrand;
}

UserCanceledPayment.prototype = new Error();
UserCanceledPayment.prototype.name = "UserCanceledPayment";
UserCanceledPayment.prototype.constructor = UserCanceledPayment;

UserCanceledPayment.prototype.ErrorNumber = CONST_ERRORS.USER_CANCELED.NUMBER;
UserCanceledPayment.prototype.ErrorDescription = CONST_ERRORS.USER_CANCELED.DESCRIPTION;

module.exports = UserCanceledPayment;


//////////////////
// WEBPACK FOOTER
// ./models/errors/userCanceledPayment.js
// module id = 55
// module chunks = 0 5 20